// extracted by mini-css-extract-plugin
module.exports = {"backLink":"PageHeader_backLink__Jy1kz","container":"PageHeader_container__A1634"};